import { render, staticRenderFns } from "./RecentResources.vue?vue&type=template&id=523b698e"
import script from "./RecentResources.vue?vue&type=script&lang=js"
export * from "./RecentResources.vue?vue&type=script&lang=js"
import style0 from "./RecentResources.vue?vue&type=style&index=0&id=523b698e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports